module.exports = __webpack_public_path__ + "img/70_42.c5944249.png";